import platformUtils from 'platformUtils';
import _ from 'lodash';

function addAppStudioWidgetPropsToSelector(props) {
    if (!self.$widget){return;}
    self.$widget.props = {};
    _.forEach(props, (val, key) => {
        Object.defineProperty(self.$widget.props, key, {
            writable: false,
            value: val
        });
    });
}

function addAppStudioGlobalsIfNeeded() {
    const RGI = platformUtils.getRGI();
    if (RGI.getIsApplicationStudio()) {
        self.$widget = {};
        self.$widget.fireEvent = function (eventName) {
            console.log(`Event Fired: ${eventName}`);
        };
        self.$widget.onPropsChanged = function (callback) {
            RGI.addOnWidgetPropsChangedCallback((oldProps, newProps) => {
                callback(oldProps, newProps);
            });
        };
    }
}

export default {
    addAppStudioWidgetPropsToSelector,
    addAppStudioGlobalsIfNeeded
};


// WEBPACK FOOTER //
// ./js/modules/privates/utils/appStudioUtils.es6